// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".day .el-table__header-wrapper{height:1.823vw}.day .el-table__header-wrapper .el-table__header{height:1.823vw!important}.day .el-table__header-wrapper .el-table__header tr th{background-color:#ebebec!important;color:#555!important;font-size:.729vw!important;padding:0!important;height:1.823vw!important;font-weight:400!important;text-align:center}.day .el-table__body-wrapper tr td{text-align:center}", ""]);
// Exports
module.exports = exports;
